// This is just an example,
// so you can safely delete all default props below

export default {
  failed: 'Action failed',
  success: 'Action was successful',
  title: {
    preview: 'Preview',
    cropImage: 'Crop image',
    attention: 'Attention',
    changeBookCoverTemplate: 'Change PDF cover template',
    shareThisArticle: 'Share this article',
    insertEmbed: 'Insert embed',
    insertImage: 'Insert image',
    insertLink: 'Link entfernen',
    book: 'Book',
    addAutoresponders: 'Add autoresponders',
    editAutoresponder: 'Edit autoresponder',
    passwordError: 'Password error',
    general: 'General',
    salesPage: 'Sales page',
    design: 'Design',
    seo: 'SEO',
    access: 'Access',
    passwordDidntWork: 'Unfortunately, the password did not work',
    accessSentToEmail: 'Access to the PDF has been sent to your email',
    openBook: 'Open PDF',
    myBook: 'My PDF',
    myProfile: 'My Profile',
    logout: 'Logout',
    profile: 'Profil',
    security: 'Security',
    changePassword: 'Change password',
  },
  socialMedia: {
    embeddable: 'Embeddable',
    notifySubscribers: 'Notify subscribers',
    madeForKids: 'Made for kids',
    fbReelRatioError: 'Your video doesn\'t have the correct aspect ratio of 9x16 (vertical) for Facebook',
    fbReelResolutionError: 'Minimum resolution is 540 x 960 pixels. Recommended resolution is 1080 x 1920 pixels.',
    fbReelLengthError: 'Reels duration must be between 3 and 90 seconds.',
    threadsConnectDescription: 'FunKISocial will automatically try to connect to whichever account you\'re logged into in your browser, so we recommend logging into threads.net with the account you want to connect to FunKISocial first and then heading to FunKISocial to connect the channel',
    letsKeepGoing: 'Let\'s keep going',
    couldntConnectYoutube: 'Whoops, we couldn\'t find any YouTube channel in your account',
    makeSureYouAreSigningInYoutube: 'Make sure you\'re signing in with a YouTube account with existing YouTube channels',
    authPageFullAccess: 'Also on the authorization page, make sure that you have given full access.',
    couldntConnectThreads: 'Whoops, we couldn\'t connect Threads profile',
    tryAgainLaterThreads: 'Try again later. On the authorization page, make sure that you have given full access to the FunKISocial App. If this fails, try revoking access to the FunKITools App in the Threads privacy settings and try the connection process again.',
    learnMoreHowToRevoke: '<a href="https://www.facebook.com/help/instagram/342170118538764" target="__blank" class="text-primary">Learn more about how to revoke access for external Apps.</a>',
    instagramSupportOneMedia: 'Instagram API supports only one media file for Story.',
    socialMediaPlaner: 'Social media Planner',
    mediaPlaner: 'Media Planner',
    mediaPlanerDescription: 'Unlock your social media success with a social media planner! It\'s your ultimate tool for effortless content scheduling and organization on platforms like Facebook, Instagram, and Twitter. Say goodbye to the chaos and hello to a strategic, consistent online presence. Boost your brand, engage your audience, and achieve your marketing goals with ease',
    manageYourChannels: 'Manage your channels',
    disconnect: 'Disconnect',
    disconnected: 'disconnected',
    notConnected: 'not connected',
    refreshConnection: 'Refresh connection',
    disconnectChannel: 'Disconnect Channel',
    deleteChannel: 'Delete channel',
    facebookTip: 'Connecting Facebook Pages and Groups is a breeze! By integrating these social media platforms, you can easily manage and engage with your audience. Simply click on the respective platform\'s icon, follow the authorization process, and voila! You\'ll have seamless access to your Pages and Groups, empowering you to streamline your social media efforts.\n',
    instagramTip: 'Connecting Instagram with just a few steps! With this integration, you can effortlessly manage your Instagram presence. Click on the Instagram icon, complete the authorization process, and gain access to your photos, followers, and engagement metrics. It\'s never been easier to stay on top of your Instagram game!',
    twitterTip: 'Integrating Twitter with your software is quick and simple! With this connection, you can efficiently manage your Twitter presence. Just click on the Twitter icon, go through the authorization steps, and you\'ll be all set to access and manage your tweets, followers, and more.',
    noChannels: 'You don\'t have any channels yet',
    connectFirstChannel: 'Connect your first channel',
    connect: 'Connect',
    connected: 'Connected',
    connectSuccessful: 'Connect was successful',
    wellDone: 'Well done!<br> You\'ve connected a Channel',
    successfullyConnected: 'You\'ve successfully connected a channel. Now you can begin scheduling posts to it.',
    goToPlanner: 'Go to planner',
    somethingWrong: 'Oops, something went wrong',
    tryAgain: 'Try again. If doesn\'t work, check if you\'re doing everything correctly in our instruction',
    establishingConnection: 'Establishing a connection',
    disconnectChannelTitle: 'You\'re about to disconnect this channel from your organization.',
    notAbleToPost: 'You will no longer be able to post to this account, all existing posts, analytics, campaigns, and data will be deleted and cannot be recovered.<b>This action cannot be undone</b>>',
    haveIssues: 'Having issues with your connection? We advice using the refresh connection option',
    facebookType: 'Select Facebook account type',
    linkedinType: 'Select LinkedIn account type',
    checkGuide: 'Check out our guide to supported account types for more details.',
    linkedinPage: 'LinkedIn page',
    linkedinProfile: 'LinkedIn profile',
    linkedinPageDescription: 'A public page',
    linkedinProfileDescription: 'A public profile',
    facebookPage: 'Facebook page',
    facebookPageDescription: 'A public profile that Facebook users "like"',
    facebookGroup: 'Facebook Group',
    facebookGroupDescription: 'A community that Facebook users join as members',
    facebookGroupDescriptionNotAvailable: 'Direct publishing to Facebook Groups is no longer supported by Meta.',
    startConnecting: 'Start Connecting',
    likeToAdd: 'Which channels would you like to add?',
    addLimit: 'You can add up to 2 more social accounts',
    seeingUnenviableChannels: 'Seeing unenviable channels?',
    learnWhy: 'Learn why',
    Today: 'Today',
    DayIsOver: 'The day is over',
    createPost: 'Create post',
    CreateNewPost: 'Create new post',
    attachOnlyOne: 'We can only attach one type of file at the same time: either images, or a gif, or a video.',
    uploadLimit: 'We can only upload 10 files in total.',
    generateImageWithAI: 'Generate image with AI',
    pictureDescription: 'Description of the picture',
    picturePlaceholder: 'Artificial Intelligence in Copyrighting',
    media: 'Media',
    addMedia: 'Add media',
    generateWithAI: 'Generate with AI',
    or: 'or',
    text: 'Text',
    writeText: 'Write a text',
    facebookLimit: 'Facebook supports up to ether 10 images or 10 videos',
    TwitterLimit: 'Twitter supports up to 4 images or one video',
    InstagramLimit: 'Instagram supports up to 10 images and videos',
    seeMore: 'See more',
    pinterestErrorTitle: 'Sorry, we only support Pinterest business accounts.',
    pinterestError: 'Unfortunately, we\'re unable to connect to Pinterest personal accounts. Are you up for connecting a Pinterest business account instead? In case it helps, here are some <a class="text-primary" href="{href}" target="_blank">instructions for converting your personal account to a business account.</a>',
    postStatus: {
      sent: 'Published',
      error: 'Error',
      draft: 'Draft',
      scheduled: 'Scheduled',
    },
    publishTo: 'Publish to',
    publishIn: 'Publish in',
    scheduleDate: 'Schedule date',
    customizeForEach: 'Customize for each network',
    schedulePosts: 'Schedule posts',
    schedulePost: 'Schedule post',
    authorizationFailed: 'Authorization failed, try to repeat the request by clicking the button below',
    reauthenticate: 'Reauthenticate',
    selectChannel: 'Please select a channel above to continue',
    workSaved: 'You work has been saved',
    connectionError: 'Connection error',
    validation: {
      minLength: 'Content should not be empty',
      maxLength: 'Post size exceeds maximum allowed size',
      minItems: 'Media should not be empty',
      maxItems: 'Too many images for post',
      pattern: 'Invalid file format for image',
      linkFormat: 'Link should be in uri format',
      mediaTypes: 'Media cannot be mixed. Select either image or a single video.',
      addVideo: 'You need to select Thumbnail for your video',
      addItem: 'Video or image is required for Story, please add one',
      privacy: 'Privacy is required',
    },
    modal: {
      authenticate: 'Authenticate',
      wait: 'Wait.. why do I have to authenticate with Facebook?',
      inOrder: 'In order for femTexter to post on your behalf on your chosen Facebook pages or groups, it needs to get some important permissions, without which it will not be able to edit publications.',
      facebookRequiresInstagram: 'Facebook requires Instagram Business or Creator accounts to be connected to a Facebook Page. For FunKISocial to work as intended, we need to authenticate through Facebook.',
      isItSave: 'Is it safe?',
      whatHappensNext: 'What happens next?',
      restAssured: 'Rest assured, we securely store your data and your access to social networks under protection. Moreover, we only store a temporary token that you can revoke at any time in Facebook or femTexter by clicking disconnect next to the Facebook Сhannel.',
      onceWeTransfer: 'Once we transfer you, sign in to the Facebook profile that has Admin permissions for the Facebook Page connected with your Instagram account.',
      authenticateWithFacebook: 'Authenticate with Facebook',
      goToLinkedin: 'Go to LinkedIn',
      beforeYouStart: 'Before you start...',
      linkedinInfo: 'We\'re going to take you to LinkedIn to connect your account with femTexter.',
      linkedinInfoBottom: 'If you are already logged into LinkedIn, double check you\'re connecting the correct account.',
      noPagesAvailable: 'There are no pages available in the account.',
      noGroupsAvailable: 'There are no groups in your account where you are the administrator',
      notice: 'Instruction',
      addToFb: '<p class="text-21-700 text-center">Add femTexter app to your<br/>Facebook Group</p><p>To finish connecting your Group,  you’ll need to add femTexter as an app on Facebook.</p><p>You will need to complete these steps on a computer, as opposed to on a mobile device. <br/>1. Log into your Facebook profile that has the admin role on the group you\'d like to connect, and then navigate to that group. <br/>2. Click Settings on the left hand side. <br/>3. Find the Advanced Settings section towards the bottom of the page and then click the edit icon to the right of Apps. <br/>4. Click Add Apps. <br/>5. Search for femTexter and then click the femTexter app that shows up in the results. <br/>6. Then, click Add.</p><p>Go to your Group Settings page and look for Advanced Settings, then edit your apps to add femTexter.</p>',
      continueWithFb: 'Continue to Facebook',
      instagramNoEntriesErrorTitle: 'We couldn’t find any Instagram Accounts connected to that account.',
      instagramNoEntriesErrorDescription: 'Make sure you’re signing in with the Facebook account that has admin permissions for the Account you’re looking to connect.<br><br>Read more about <a class="text-primary" href="https://help.instagram.com/502981923235522" target="_blank">how to set up a business account on Instagram</a> and how to <a class="text-primary" href="https://www.facebook.com/business/help/connect-instagram-to-page" target="_blank">connect Facebook Business Page to Instagram Business</a>',
    },
    scheduledInPast: 'The scheduled time seems to be in the past',
    revoke: {
      statusOfData: 'Status of delete user data',
      insertCode: 'Insert code',
      checkStatus: 'Check status',
      dataDeleted: 'Data deleted',
      noUser: 'User does not exist',
      noUserDesc: 'Unfortunately, we did not find such a user.<br/>It does not exist or there was an input error',
    },
    descriptionReduced: 'We cut the number of characters in the description based on the available character limit.',
    hasNoPermission: 'You do not have a permission to publish a post.',
    needToUpdateSchedule: 'You need to schedule your update for some time in the future!',
    cantConnectInstagram: 'If you can\'t connect your Instagram channel, you can find possible reasons <a class="text-primary text-14-700" target="_blank" href="https://www.facebook.com/business/help/connect-instgram-to-page">here</a>!<br> Take a close look at all the steps under the following link:<a class="block text-primary text-14-700" target="_blank" href="https://www.facebook.com/business/help/connect-instgram-to-page">https://www.facebook.com/business/help/connect-instgram-to-page</a> ',
    post: 'Post',
    reel: 'Reel',
    story: 'Story',
    deleteImagesReel: 'You have to delete images in order to create a Reel',
    selectPagesReel: 'Reels can be created only for facebook pages',
    deleteImagesStory: 'You have to delete images in order to create a Story',
    deleteVideoPost: 'Only Reels or Story can be published if videos are attached.',
    destinationLink: 'Destination link',
    pinningTo: 'Pinning to',
    searchYourBoards: 'Search your boards',
    noBoards: 'Looks like this profile doesn\'t have any boards yet. Go to profile and create your first board.',
    noVideoInstagramPost: 'Instagram no longer supports standard video posts. Please, use Reels or Story for posting video',
    noPhotoReels: 'Instagram Reel does not support images. You can add videos in MOV, MP4 formats.',
    noPhotoReelsFb: 'Facebook Reel does not support images. You can add videos in MOV, MP4 formats.',
    noPhotoShorts: 'YouTube shorts does not support images. You can add videos in MOV, MP4 formats.',
    disableComments: 'Comment',
    disableDuet: 'Duet',
    disableStitch: 'Stitch',
    tiktokPrivacy: {
      publicToEveryone: 'Public / Friends',
      mutualFollowFriends: 'Mutual follow friends',
      followerOrCreator: 'Follower or creator',
      selfOnly: 'Private (Only me)',
    },
    privacy: 'Privacy',
    postWillBePosted: 'The post will be published in the near future',
    toConnectInstagramAccount: 'To connect Instagram account Facebook requires <span class="text-black">Instagram Business or Creator accounts to be connected to a Facebook Page.</span> For FunKISocial to work as intended, we need to authenticate through Facebook.',
    readMoreAboutInstagramBusiness: 'Read more about <a href="https://help.instagram.com/138925576505882" target="__blank" class="text-primary">Instagram Business or Creator accounts on Instagram.</a>',
    makeSureYouAreSigningInInstagram: 'Please make sure you\'re signing in with a <span class="text-black">personal Facebook profile, that has the admin role for the page that is connected to Instagram Business or Creator accounts</span> you\'re trying to connect.',
    error: {
      bannedFromPosting: 'TikTok is not allowing this post to publish due to the TikTok account being banned.',
      tooManyPosts: 'The daily post cap from the API is reached for the current user.',
      reachedCap: 'The daily quota for active publishing users from your client is reached.',
    },
  },
  auth: {
    signInToFunKITools: 'Sign in to FunKITools',
    email: 'Email',
    password: 'Password',
    confirmPassword: 'Confirm Password',
    signIn: 'Sign in',
    forgotPassword: 'Forgot password?',
    restore: 'Restore',
    newUser: 'New User?',
    createAccount: 'Create account',
    alreadyHaveAnAccount: 'Already have an account?',
    getOneFreeMinutes: 'Get 1 Free Minutes:',
    signUpNow: 'Sign Up Now!',
    registration: 'Registration',
    byContinuingYouAgreeTo: 'By continuing, you agree to',
    termsOfUse: 'Terms of Use',
    and: 'and',
    privacyPolicy: 'Privacy policy',
    forgotYourPassword: 'Forgot your password?',
    enterYourEmailToResetPassword: 'Enter your email to reset password',
    sendEmail: 'Send email',
    back: 'Back',
    createNewPassword: 'Create new password',
    yourNewPassword: 'You new password must be different from previous used passwords',
    restorePassword: 'Restore password',
    imprint: 'Imprint',
    checkYourMail: 'Check your mail',
    weSentPassword: 'We have sent a password recover instructions to your email',
    passwordChanged: 'Password changed successfully',
    login: 'Login',
    withNewPassword: 'with new password',
  },
  text: {
    currentText: 'Current text',
    generatedText: 'Generated text',
    uploadCoverBook: 'Upload cover book',
    youWillLoggedOut: 'You will be logged out in...',
    weSentNotificationWithConfirmLink: 'We have sent a notification with an email confirmation link to',
    copyrightAllRightsReserved: 'Copyright. All Rights Reserved',
    loginTourAccount: 'or login to <a class="link-color cursor-pointer" href="{href}" target="_blank">your account</a>',
    checkYourEntry: 'You may have made a mistake, check your entry is correct',
    checkInbox: 'Check your inbox and follow the instructions',
    deleteAutoresponderConfirm: 'Delete this autoresponder for this form?',
    exportContacts: 'Exporting contacts.',
    youDontHaveLeads: 'You don\'t have any leads yet',
    fillOutTheBlog: 'Fill out the blog, post and enable subscription and the service will start collecting leads',
    customFont: 'Custom font',
    theseAreTheSuggestedChaptersOfYourBook: 'These are the suggested chapters of your book. You can adjust them here and add or remove chapters if you wish.',
    generatedChaptersNumber: 'The number of generated chapters may differ from the desired one.',
    emails: 'Emails',
    titleLockScreen: 'Title lock screen',
    descriptionLockScreen: 'Description lock screen',
    payment: 'Payment',
    productDefault: 'Product default',
    background: 'Background',
    paywall: 'Paywall',
    customDomain: 'Custom domain',
    freeBook: 'Free PDF',
    generalColor: 'General colors',
    shareToUnlock: 'Share to unlock',
    dragOrClickToLoadImage: 'Drag or <span>click</span> to load image',
    clickToLoadImage: '<span>Click</span> to load image',
    addUserToSpreadSheet: 'Add this user "<b>{0}</b>" to your Google SpreadSheet with "Edit" permissions',
    codeCopiedSuccessfully: 'Code copied successfully',
    textCopiedSuccessfully: 'Text copied successfully',
    urlCopiedSuccessfully: 'URL copied successfully',
    noSalesYet: 'No sales yet',
    yourBookHasNoSales: 'Your PDF has no active sales yet',
    youCanChangeTheCoverStyle: 'You can change the cover style',
    clickOnThePaletteIcon: 'Click on the palette icon',
    yourBook: 'Your PDF',
    whatIsThisBookAbout: 'What is this PDF about',
    newBookWithAI: 'New PDF with AI',
    pleaseFixErrors: 'Please fix validation errors for each network selected',
    ifYouHavePinterestAccount: 'If you have a <a href="https://help.pinterest.com/en/article/switch-between-accounts" target="__blank" class="text-primary">Pinterest business account linked to your Pinterest personal account</a>, you\'ll need to first log into Pinterest and make sure the account you want to connect to FunKISocial is currently selected from the dropdown in the upper right corner of Pinterest.',
    onceYouTheCorrect: 'Once you the correct account is selected, you can head back to FunKISocial to connect the Pinterest account.',
    letsConnect: 'Let\'s connect',
    repliesDesc: 'Here are all your replies that you haven\'t already marked as Replied',
    repliedDesc: 'Here are all your replies that you have marked as Replied',
    artificialIntelligenceInCopywriting: 'Artificial intelligence in Copywriting',
    selectSocialMedia: 'Select the social media you want to see relevant posts',
    generatingPicture: 'Generating picture',
    moveFileHereToUpload: 'Move file here to upload',
    deleteConfirm: 'Do you want to remove "<b>{0}</b>"?',
    files: 'files | file | files',
    inputs: 'Inputs',
    postDeleted: 'Post deleted',
    postCreated: 'Post created',
    postUpdated: 'Post updated',
    seeYourPostPreview: 'See your post\'s preview here',
    used: 'used',
    forDays: 'for {n} days',
    timesOnce: 'times once',
    viewPlanInfo: 'View plan info',
    funkitoolsBranding: 'FunKITools branding',
    youCantRemoveBranding: 'You can\'t remove <br> FunKITools branding',
    removeBranding: 'Remove FunKITools branding',
    nothingWasFound: 'Nothing was found',
    tryAgain: 'Try again',
    leads: 'Leads',
    noConnectedAutoresponder: 'You don\'t have <br> connected <br> Autoresponder',
    autoresponderSubtitle: 'Here you can create an integration with an external autoresponder (Klicktipp, Getresponse, Mailchimp...).',
    googleSpreadsheetAddUser: 'Add this user "{email}" to your Google SpreadSheet with "Edit" permissions',
    autoresponderAddedSubtitle: 'Now you can use it for subscription forms.',
    autoresponderAddedTitle: '{autoresponder} successfully <br> added',
    tableContent: 'Table of contents',
    reduceNumberOfCharacters: 'Reduce the number of characters to use Magic',
    toneOfVoice: 'Tone of Voice',
    link: 'link',
    onlyDesktop: 'Please use a PC or a tablet to use FunKITools. The mobile version is in the works',
    recommendToUseCloudFlare: 'We recommend to use CloudFlare for connecting a domain',
    cloudFlare: 'CloudFlare (connect root domain):',
    delegateDomainToCloudFlare: '1. Delegate domain to CloudFlare (skip this step if domain already connected to cloudflare)',
    waitingForDnsUpdate: '2. Waiting for DNS update (skip this step if domain already connected to cloudflare)',
    goToDnsSettings: '3. Go to DNS settings',
    clickAddRecord: '4. Click “Add record” and add these data:',
    addDomainInAffilipage: '5. Add domain in FunKItolls',
    otherProviders: 'Other providers (subdomain):',
    addSubdomainInYourDomain: '1. Add subdomain (CNAME) in your domain DNS entries manager',
    forExample: `For example: www points to ${process.env.CONNECT_DOMAIN}`,
    addDomain: '2. Add domain in FunKItolls',
    noResults: 'No results',
    requests: 'requests',
    leftOutOf: 'left out of',
    dateUntil: 'until <span class="text-black q-ml-xs">{date}</span>',
    theRequestLimitHasBeenReached: 'The request limit has been reached, please update your tariff',
    keywordSearchesUsed: 'Keyword searches used',
    postGenerationUsed: 'Post generation used',
    dateUpdatingLimits: 'Date Updating the limits',
    sorryPageNotFound: 'Sorry, the requested page was not found',
    namecheap: 'Namecheap (Connect Main Domain)',
    navigateToTheDomains: '1. Navigate to the "Domains" menu item in your FunKItolls Dashboard and click on "Add new domain" (skip this step if your domain is already connected to FunKItolls).',
    enterTheName: '2. Enter the name of the domain you want to connect. The following format is required, "mydomain.com". You will now see a "DNS Record" which we need to create at Namecheap.',
    logInToYourNamecheap: '3. Log in to your Namecheap account.',
    selectDomainList: '4. Select "Domain List" in the left sidebar and click the "Manage" button next to your domain name.',
    clickOnTheAdvancedDns: '5. Click on the "Advanced DNS" tab and find the "Host records" section. Then click the "Add new Record" button.',
    nowSelectCnameRecord: `6. Now select "CNAME Record" and enter Host: {'@'}, for Value: ${process.env.CONNECT_DOMAIN} And set TTL to: "Automatic".`,
    notice: 'Notice:',
    itMayTakeUp: 'It may take up to 48 hours for the DNS changes to take effect globally.',
    namecheapSubdomain: 'Namecheap (Connect Subdomain)',
    connectSubdomainNamecheap: 'To connect a subdomain to FunKItolls via Namecheap, follow the first 4 steps of setup for a “main” domain.',
    godaddyConnectMainDomain: 'Godaddy (Connect main domain)',
    logInToYourGodaddy: '3. Log in to your Godaddy account.',
    clickOnTheUserProfile: '4. Click on the User Profile icon in the upper right corner and select My Products.',
    clickOnDns: '5. Click on DNS to the right of your domain.',
    clickOnAdd: '6. Click on Add at the bottom right and select "CNAME".',
    inTheHostField: `7. In the Host field enter: {'@'}, for Value: ${process.env.CONNECT_DOMAIN} And set TTL to: "Automatic."`,
    godaddyConnectSubdomain: 'Godaddy (Connect Subdomain)',
    enterTheNameOfTheDomain: '2. Enter the name of the domain you want to connect. The following format is required, "mydomain.com". You will now be shown a "DNS Record" which we need to create at Godaddy.',
    toConnectSubdomain: 'To connect a subdomain to FunKItolls via Godaddy, follow the first 5 steps of setup for a "main" domain.',
    nowCreate: '1. Now create (if no subdomain entry exists yet) or edit (if subdomain entry already exists) the CNAME entry with the following parameters:',
    hostTheName: 'Host: the name of your subdomain',
    valueConnect: `Value: ${process.env.CONNECT_DOMAIN}.`,
    ttlAutomatic: 'TTL: "Automatic"',
    ionosConnectMainDomain: 'Ionos (Connect main domain)',
    enterTheNameOfTheDomainIonos: '2. Enter the name of the domain you want to connect. The following format is required, "mydomain.com". You will now see a "DNS Record" which we need to create at Ionos.',
    logYourIonos: '3. Log in to your Ionos account.',
    clickSettingsIcon: '4. Click on the settings icon for your domain and then on DNS.',
    clickAddRecordCname: '5. Now click on Add Record and select "CNAME".',
    enterFieldHostname: `6. Enter in the field Hostname: {'@'}, at Value (Points to): ${process.env.CONNECT_DOMAIN} And set TTL to: "Automatic."`,
    ionosConnectSubdomain: 'Ionos (Connect Subdomain)',
    connectSubdomain: 'To connect a subdomain to FunKItolls via Ionos, follow the first 4 steps of setup for a "main" domain.',
    hostname: 'Hostname: the name of your subdomain',
    valuePoints: `Value (Points to): ${process.env.CONNECT_DOMAIN}.`,
    stratoConnectMainDomain: 'Strato (Connect main domain)',
    enterNameDomainStrato: '2. Enter the name of the domain you want to connect. The following format is required, "mydomain.com". You will now be shown a "DNS Record" which we need to create at Strato.',
    logStrato: '3. Log in to your Strato account.',
    clickManageDomains: '4. Click on Manage Domains.',
    clickNextDomain: '5. Click next to your domain on manage.',
    clickDnsSettings: '6. Now click on DNS Settings.',
    clickManageCname: '7. Click on Manage CNAME record.',
    enterFollowing: `8. Enter the following into the field: ${process.env.CONNECT_DOMAIN} & Click on "Apply settings".`,
    stratoConnectSubdomain: 'Strato (Connect Subdomain)',
    connectSubdomainStrato: 'To connect a subdomain to FunKItolls via Strato, follow the first 4 steps of setup for a "main" domain.',
    clickSymbolNextDomain: '1. Click on the + symbol next to your domain to open the second line.',
    clickManageSecondLine: '2. Now click on Manage in the second line.',
    listSettingsDnsManagement: '3. In the list Settings (Subdomain) open the field DNS Management.',
    clickManageRecord: '4. Click on Manage CNAME record.',
    enterFollowingIntoField: `5. Enter the following into the field: ${process.env.CONNECT_DOMAIN} & Click on "Apply settings".`,
    sitegroundMainDomain: 'Siteground (connect main domain)',
    enterNameDomainSiteground: '2. Enter the name of the domain you want to connect. The following format is required, "mydomain.com". You will now be shown a "DNS Record" which we need to create at Siteground.',
    logSiteground: '3. Log in to your Siteground account.',
    navigateSiteTools: '4. Navigate to Site Tools > Domain > DNS Zone Editor.',
    clickCreateNewRecord: '5. Click on Create New Record and select CNAME.',
    selectNameField: `6. In the Select Name field enter: {'@'}, for iPv4 Address: ${process.env.CONNECT_DOMAIN} And set TTL to: "Automatic".`,
    finallyCreate: '7. Finally click on Create.',
    sitegroundSubdomain: 'Siteground (Connect Subdomain)',
    connectSubdomainSiteground: 'To connect a subdomain to FunKItolls via Siteground, follow the first 4 steps of setup for a "main" domain.',
    createOrEdit: '1. Now create (if no subdomain entry exists) or edit (if subdomain entry already exists) the CNAME entry with the following parameters:',
    selectNameYourSubdomain: 'Select Name: the name of your subdomain',
    addressConnectAffilipage: `iPv4 Address: ${process.env.CONNECT_DOMAIN}`,
    allInklMainDomain: 'All-inkl (Connect main domain)',
    enterNameAllInkl: '2. Enter the name of the domain you want to connect. The following format is required, "mydomain.com". You will now be shown a "DNS Record" which we need to create at All-inkl.',
    logAllInkl: '3. Log in to your All-inkl account.',
    technicalAdministration: '4. Navigate via the menu links to "Technical Administration".',
    clickOnKasLogin: '5. Click on "KAS Login" on the right side.',
    clickDomainLinks: '6. Click on "Domain" from the Links menu.',
    DnsSettingsDomain: '7. On the right side next to your domain click on "Edit" and then at the bottom on "DNS settings for this domain".',
    clickCreateNewDnsEntry: '8. Click on "Create new DNS entry" and select CNAME as "Type".',
    enterFieldNameData: `9. Enter in the field Name: {'@'} and for Data: ${process.env.CONNECT_DOMAIN}.`,
    itMayTakeUpWorldwide: 'It may take up to 48 hours for the DNS changes to take effect worldwide.',
    allInkSubdomain: 'All-inkl (Connect Subdomain)',
    connectSubdomainAllInkl: 'To connect a subdomain to FunKItolls via All-inkl, follow the first 7 steps of setup for a "main" domain.',
    nameYourSubdomain: 'Name: the name of your subdomain',
    dataConnectAffilipage: `Data: ${process.env.CONNECT_DOMAIN}.`,
    reachable: 'Reachable',
    sslConnected: 'SSL connected',
    domainDisconnected: 'Domain disconnected',
    noReachable: 'No reachable',
    sslDisconnected: 'SSL disconnected',
    domainPageHint: 'You can attach your domains to funnels. If you need help, you can see our {0} on how to add domains',
    instructions: 'instructions',
    type: 'Type:',
    cname: 'CNAME',
    name: 'NAME: {\'@\'}',
    target: 'Target:',
    proxyStatus: 'Proxy status:',
    off: 'Off',
    ttl: 'TTL:',
    auto: 'Auto',
    postTitlePlaceholder: 'e.g. Pouring Perfection: Exploring the Rich World of Red Wine',
    postTitleTip: 'Leave blank to let AI generate',
    connectDomain: `${process.env.CONNECT_DOMAIN}`,
    attention: 'Attention',
    resetStylesToDefault: 'Do you want to reset <br> styles to default?',
    beCarefulThisAction: 'Be careful this action <br> cannot be undone',
    content: 'Content',
    words: 'words',
    uploadFavicon: 'Upload favicon',
    amongTheMostCrucial: 'Among the most crucial elements in <br> SEO is a strong title that match users search intent.',
    goodMetaDescription: 'A good meta description is a brief summary aimed at <br> enticing users to click through in search results.',
    contentShouldBeSimilar: 'Content should be similar in length to competitors\' <br> while remaining concise and informative.',
    unfortunatelyPageNotFound: 'Unfortunately, the page was not found, or was moved somewhere.',
    returnToThe: 'Return to the',
    mainPage: 'main page',
    homePage: 'home page',
    orContactSupport: 'or contact the support',
    returnToDashboard: 'Return to Dashboard',
    returnToHomepage: 'Return to home page',
    contentRecommendation: 'Content recommendation',
    recommendedWordCount: 'Recommended word count',
    editTemplate: 'Edit template',
    comingSoon: 'Coming <br> soon',
    viewAll: 'View all',
    articleSettings: 'Article settings',
    doYouWantToDelete: 'Do you want to delete <br> {name}?',
    createNewContent: 'Create new content',
    adjustTheOutline: 'Adjust the outline before generation of content for the <br> keyword ',
    generatingOutline: 'Generating oultine...',
    subheadings: 'Subheadings',
    domainAdded: 'Domain added <br> successfully',
    domainAddedSubtitle: 'Your domain was added <br> and will be available for usage soon',
    howToConnectDomain: 'How to connect a domain?',
    domainIsNotConnected: `Domain is not connected. <br> Please check your DNS settings, if your domain<br> points to ${process.env.CONNECT_DOMAIN}`,
    domainConnected: 'Domain connected',
    sslIsNotConnected: 'SSL is not connected',
    createLink: 'Create link',
    externalUrl: 'External URL',
    internalUrl: 'Internal URL',
    connectingYourDomain: 'Connecting your domain',
    helpCenter: 'Help center',
    keywordDistribution: 'Keyword distribution',
    distributionOfTheMainKeyword: 'This is the distribution of the main keyword across <br> the top 10 search results for the target keyword',
    image: 'Image',
    metaDescription: 'Meta description',
    metaKeywords: 'Meta keywords',
    titleCompetitive: 'Title competitive score (tcs)',
    settings: 'Settings',
    noSSL: 'No SSL',
    uploadYourOwnImage: 'Upload your own image',
    editLink: 'Edit link',
    viewLink: 'View link',
    copyUrl: 'Copy URL',
    uploadingAnImage: 'Uploading an image',
    pleaseWait: 'Please wait',
    changeImage: 'Change image',
    dragOrClickToChangeThePicture: 'Drag or click to <br> change the picture',
    uploadFile: 'Upload file',
    uploadFromCloud: 'Upload from Cloud',
    addHeading: 'Add heading',
    templatePreview: 'Template preview',
    noConnectedDomains: 'You don\'t have<br> connected domains',
    noConnectedDomainsSubtitle: 'Please connect a domain to your blog. You will find all your domains here.',
    yourDocumentReady: 'Your document is ready!',
    targetKeyword: 'Target keyword',
    writeAndAnalyze: 'Write & analyze...',
    identifyingSearchIntents: 'Identifying search intents...',
    aiExplorer: 'AI Explorer',
    myKeywords: 'My keywords',
    searchOrKey: 'Search or key',
    typeSeedKeywordOrDescription: 'Type seed keyword or description <br> and find keywords',
    setTheDefaultLanguage: 'Set the default language for system',
    noArticle: 'No articles yet',
    noArticleDescription: 'Perhaps the author has not yet marked the articles',
    exampleKeyword: 'e. g. video games',
    characters: 'characters',
    you: 'You',
    myDomains: 'My domains',
    addUrl: 'Add URL',
    whatsNew: 'What\'s new?',
    new: 'new',
    emptyBrandVoiceSubtitle: 'Let’s start create your brand voice, just click on New Voice.',
    brandVoiceSubtitle: 'Your Brand Voice enables FunKITools to access information unique to what you are writing, as well as your specific tone(s) and style(s), ensuring that every piece of content he creates accurately represents your brand voice. To begin, provide background information specific to the content you are creating.',
    smtpSubtitle: 'By "Default SMTP" our system is sending emails. To have your own email address and a better delivery rate you can activate your own SMTP. For using your own SMTP you have to disable "Default SMTP". IMPORTANT: Use port 587 for outgoing server.',
    noConnectedVoice: 'You don\'t have <br> connected voice',
    pasteAnyText: 'Paste any text that reflects the distinctive tone of your brand here...',
    brandedText: 'Branded text',
    foxNews: 'e.g. FoxNews',
    modifyBrandVoice: 'Modify your brand voice',
    thisIsBrandVoiceInfo: 'This is the brand voice that FunKITools has synthesized from your uploaded content.',
    voiceAdded: 'Brand Voice added successfully',
    voiceAddedSubtitle: ' Now you can use it <br> to generate content.',
    internalServerError: 'Internal server error',
    copyAsText: 'Copy as text',
    copyAsHtml: 'Copy as HTML',
    markdown: 'Markdown',
    doYouWantToCollect: 'Do you want to collect contacts?',
    youWillBeAbleToSend: 'You will be able to send email chains to your contacts and notify about new posts',
    enableNewsletter: 'Enable Newsletter',
    notSelected: 'Not selected',
    youCanCustomizeDescription: 'You can also customize the description',
    youCanChangeTheDescription: 'You can change the description texts <br> and much more in',
    customDesign: 'Custom design',
    addNewAutoresponder: 'Add new Autoresponder',
    addNewEmailChain: 'Add new Email chain',
    email_one: 'email',
    email_other: 'emails',
    newMail: 'New mail',
    pageTitlePlaceholder: 'e.g. Impressum',
    pageSlugPlaceholder: 'e.g. impressum',
    yourPageTitleHere: 'Your page title here',
    fillInTheFieldsOnTheLeft: 'Fill in the fields on the left side of the screen and then start creating the page content',
    useCreated: 'Use created',
    newPage: 'New page',
    previewNewTab: 'Preview new tab',
    yourEmail: 'Your email',
    byClickingSubscribe: 'By clicking button you agree to the',
    dataProcessingRules: 'privacy policy',
    einverstanden: '',
    successful: 'Successful',
    youHaveSubscribed: 'You have successfully <br> subscribed',
    youWillReceiveNews: 'You will receive new emails to <br>',
    noConnectedEmailChains: 'You don\'t have <br> connected Email chains',
    emailChainsSubtitle: 'Here you can create Email chains, that will be sent by our autoresponder. You can reuse already created Email chains.',
    email: '{n} E-mails | {n} E-mail | {n} E-mails',
    emailChain: 'Email chain',
    emailChainAdded: 'Email chain added <br> successfully',
    emailChainAddedSubtitle: 'It remains to select them in the Blog settings in the Newsletter section.',
    willBeSentVia: 'will be sent via',
    hour: '{n} hours | {n} hour | {n} hours',
    day: '{n} days | {n} day | {n} days',
    editMail: 'Edit mail',
    previewMail: 'Preview mail',
    duplicateMail: 'Duplicate mail',
    deleteMail: 'Delete mail',
    hours: 'Hours',
    seconds: 'Seconds',
    days: 'Days',
    minutes: 'Minutes',
    defaultSmtp: 'Default SMTP',
    youAreUsingDefaultSmtp: 'You are using Default SMTP',
    byDefaultSmtpDesc: 'By "Default SMTP" our system is sending emails. To have your own email address and a better delivery rate you can activate your own SMTP. For using your own SMTP you have to disable "Default SMTP". IMPORTANT: Use port 587 for outgoing server.',
    helpIsNeeded: 'Help is needed?',
    writeToOurAssistent: 'Write to our assistant, he will answer everything',
    write: 'Write',
    none: 'None',
    enableDoi: 'Enable DOI',
    addHeaders: 'Add headers',
    selectSomeText: 'Select some text to use Magic',
    videoEmbed: 'Embed video',
    videoEmbedPlaceholder: 'e.g. https://www.youtube.com/embed/sss?si=jdsj',
    selectBrandVoice: 'Select brand voice',
    generateWithAI: 'Generate with AI',
    removeImage: 'Remove image',
    sitemapInProcess: 'The sitemap is in the process of being generated',
    sitemapGenerationWillTakeTime: 'The sitemap generation will take some time, you will see a button with a download link here as soon as it is generated.',
    willBeGenerated: 'Will be generated',
    thisIsYourSitemap: 'This is your blog\'s sitemap',
    hereYouCanDownloadSitemap: 'Here you can download sitemap and place it where you need it, for example in the Google Search Console',
    myBlogs: 'My blogs',
    addNewBlog: 'Add new blog',
    blogsHaveBeenCreated: '{uses} out of {limit} blogs have been created.',
    blogsLimitReached: '{uses} out of {limit} blogs have been created. To create more blogs, upgrade tariff.',
    youCreatingEmptyPost: 'You are creating an <br> empty post',
    ifYouNeedHelpFromAI: 'If you need help from AI, <br> go to creation using AI',
    youHaveReachedLimit: 'You have reached your blog creation limit. Upgrade to create more blogs.',
    firstWriteText: 'First, write the text (500 words minimum) of the post and then start the analysis.',
    noinexTooltip: 'If active, the page will not be indexed by search engines.',
    synchronizeThePost: 'Synchronize the post with your external website',
    hereAreTheWebsites: 'Here are the websites to which it is possible to synchronize the post.',
    noSitesFound: 'No sites found',
    makeSureThatYouHavePlugin: 'Make sure that you have installed the FunKITools plugin on your WordPress website, activated it and set the key in the plugin settings.',
    syncing: 'Syncing...',
    notSynchronized: 'Not synchronized',
    successfully: 'Successfully',
    syncingFailed: 'Syncing failed',
    weRecommendHidingPosts: 'We recommend hiding posts published on external sites from search engines or making them unpublished. To hide posts from indexing, click on the gear icon gear in the top menu of the post editor and activate the “No index” option.',
    doYouWantTosynchronizePost: 'Do you want to synchronize the post with {website}?',
    peopleAlsoAskLegend: 'The \'People Also Ask\' questions based on the SERP for the target keyword.',
    aiQuestionsLegend: 'Questions that are natural related to your target keyword based on AI analysis.',
    relatedQuestionsDescription: 'Incorporating Google\'s \'People Also Ask\' questions is an excellent content starting point.',
    confirmAccountDeletion: 'Confirm account deletion',
    noAccountRestore: 'Please note that it will not be possible to restore your account.',
    metaTagFieldDescription: 'One of the mandatory requirements for inserting meta tags is the quotation mark format. Do not use slanted quotes such as (”) use (").',
    nofollowTooltip: 'Nofollow links are links with a rel="nofollow" attribute applied to them. The "nofollow" attribute tells search engines to ignore that link.',
    noAccessToPlugin: 'No access to <br> WordPress plugin',
    updateYourPlan: 'To use this option, <br> upgrade your plan',
    noAccessToSyncing: 'No access to <br> syncing with <br> WordPress',
    doYouWantToDeleteAllRecords: 'Do you want to delete all entries from your keyword search history?',
    doYouWantToDeleteSingleRecord: 'Do you want to delete the keyword history for the “{seed}” query?',
    noAccessTo: 'No access to <br> {feature}',
    noAccessToUse: 'No access to use {feature}',
    keywords: '{n} keywords | {n} keyword | {n} keywords',
    addedToFavourite: 'Added to favorite',
    notAvailableInCurrentPlan: 'Not available in current plan',
    noAccessToThisTemplate: 'No access to this <br> template',
    noAccessToAddCustomBanner: 'No access to add <br> custom banner',
    createdBy: 'Created by',
    welcomeToFunkiblog: 'Welcome to <br> FunKIBlog',
    pleaseWatchTheVideo: 'Please watch this video <br> before using the service',
    videoAvailable: 'Video available until countdown is at 0',
    promoAccess: 'Only within 72 hours you have access to a discount offer on the PRO tariff',
    minTime: 'min',
    secTime: 'sec',
    discountOffer: 'Only within 72 hours you have access to <br> a discount offer on the PRO tariff',
    hoursPlural: '{n} hours | {n} hours | {n} hours',
    minutesPlural: '{n} minutes | {n} minutes | {n} minutes',
    secondsPlural: '{n} seconds | {n} seconds | {n} seconds',
    notAvailable: 'Not available',
    keywordSearchRequests: 'keyword search requests | keyword search request | keyword search requests',
    recalculationLimits: 'Recalculation of the SEO Score is not available because the limit has been reached. Upgrade your plan to use all features.',
    optimizingLeft: 'Seo Optimizing limit left',
    thereAreDaysLeft: 'There are {n} days left until the end of the free calculate the SEO score.',
    featureIsNoLongerAvailable: 'This feature is no longer available for your current plan.',
    youCanNoLongerRecalculate: 'You can no longer <br> recalculate the SEO Score',
    thereWereNoitemsFound: 'There were no items found',
    postAuthor: 'Post author',
    listOfAuthors: 'The list of authors that will be displayed at the end of the article.',
    editAuthors: 'Edit authors',
    authors: '{n} authors | {n} author | {n} authors',
    authorAdded: 'Author added successfully',
    metaAuthorTagDescription: 'The Meta author tag indicates the author of the content, which is important for search engines to improve your online reputation, credibility and audience trust.',
    welcomeTo: 'Welcome to',
    fun: 'Fun',
    tools: 'Tools',
    powerfulToolsDescription: 'Powerful tools based on artificial intelligence.',
    createContentEasily: 'Create content easily with FunKI Tools!',
    blogServiceDescription: 'Сreate unique content, manage and optimize your blogs using artificial intelligence.',
    socialServiceDescription: 'Create posts on popular social networks using artificial intelligence, and publish at any time.',
    profileDescription: 'Want to change your email, password, or the language? This way for you!',
    goTo: 'Go to',
    profile: 'Profile',
    noAccess: 'No access',
    didNotFindFunctionality: 'Did not find the required functionality?',
    writeToSupport: 'Write to support',
    channelsDescription: 'Here is the list of your connected channels.',
    connectYourChannels: 'Connect your channels',
    unlockYourSocialMedia: 'Unlock your social media success with a FunKISocial! It\'s your ultimate tool for effortless content scheduling and organization on platforms like Facebook, Instagram, and Twitter. Say goodbye to chaos and hello to a strategic, consistent online presence. Increase your brand, inspire your target group and fulfill your marketing goals very easily!',
    allChannels: 'All channels',
    forSmallBusinesses: 'For Small Businesses',
    forCreators: 'For Creators',
    forCommerce: 'For E-commerce',
    waitWhyDoI: 'Wait... why do I have to authenticate with Facebook?',
    inOrderForFunkisocial: 'In order for FunKISocial to post on your behalf on the Facebook pages you have selected, you need to <span class="text-black">accept all permissions for all pages</span> (even the ones that aren\'t going to be connected to FunKISocial).',
    isItSafe: 'Is it safe?',
    readMoreAboutHowToCreate: '<a href="https://www.facebook.com/help/104002523024878" target="__blank" class="text-primary">Read more about how to create a page.</a>',
    toConnectFacebookPage: 'To connect a Facebook Page to your FunKISocial account, you\'ll <span class="text-black">need to authenticate through a personal Facebook profile, that has the admin role on the page</span> you\'re looking to connect.',
    restAssuredWeSecurely: 'Rest assured, we securely store your data and your access to social networks under protection. Moreover, we only store a temporary token that you can revoke at any time in <a href="https://www.facebook.com/settings?tab=business_tools" target="__blank" class="text-primary">Facebook Business Integrations</a> or in FunKISocial by clicking disconnect next to the Facebook channel.',
    somethingWentWrong: 'Oops, something <br> went wrong',
    tryAgainLater: 'Please try again later',
    selectFacebookAccount: 'Select Facebook <br> account type',
    selectLinkedinAccount: 'Select LinkedIn <br> account type',
    checkOutOurGuide: 'Check out our guide to supported account types for more details.',
    facebookPage: 'Facebook page',
    facebookPageDescription: 'A public profile that <br> Facebook users "like"',
    facebookGroup: 'Facebook group',
    facebookGroupDescription: 'A community that Facebook users join as members',
    facebookGroupNotSupported: 'Direct publishing to Facebook Groups is no longer supported by Meta.',
    wellDoneYouAddedChannel: 'Well done! You\'ve connected a Channel',
    youSuccessfullyConnected: 'You\'ve successfully connected a channel. Now you can begin scheduling posts to it.',
    whichChannelsToAdd: 'Which channels would you like to add?',
    cantConnectInstagram: 'If you can\'t connect your Instagram channel, you can find possible reasons <a href="https://www.facebook.com/business/help/connect-instgram-to-page" target="_blank" class="text-green-3">here</a>!',
    weCouldntFindAccounts: 'We couldn\'t find any Instagram Accounts connected to that account.',
    makeSureYouAreSigningIn: 'Make sure you\'re signing in with the Facebook account that has admin permissions for the Account you\'re looking to connect.',
    readMoreAboutHowToSetup: 'Read more about <a href="https://help.instagram.com/502981923235522" target="_blank" class="text-green-3">how to set up a business account on Instagram</a> and how to <a href="https://www.facebook.com/business/help/connect-instagram-to-page" target="_blank" class="text-green-3">connect Facebook Business Page to Instagram Business</a>',
    weCouldntFindAccountsFacebook: 'Whoops, we couldn\'t find any facebook page in your account',
    makeSureYouAreSigningInFacebook: 'Please make sure you\'re signing in with a personal Facebook profile, that has the admin role for the page you\'re trying to connect.',
    readMoreAboutHowToSetupFacebook: '<a href="https://www.facebook.com/help/104002523024878" target="__blank" class="text-primary">Read more about how to create a page.</a>',
    linkedinPage: 'LinkedIn page',
    linkedinPageDescription: 'A public page',
    linkedinProfile: 'LinkedIn profile',
    linkedinProfileDescription: 'A public profile',
    goToLinkedin: 'Go to LinkedIn',
    beforeYouStart: 'Before you start',
    linkedinConnectDescription: 'We\'re going to take you to LinkedIn to connect your account with FunKITools.',
    linkedinConnectDescriptionBot: 'If you are already logged into LinkedIn, double check you\'re connecting the correct account.',
    welcomeToFunkisocial: 'Welcome to FunKISocial',
    connectYourFirstChannel: 'To get started, you need to connect your first channel',
    generateTextWithAi: 'Generate text with AI',
    left: 'left',
    socialNetwork: 'Social network',
    posts: 'Posts',
    postsN: '{n} posts | {n} post | {n} posts',
    noPosts: 'No posts',
    addNewPost: 'Add new post',
    january: 'January',
    february: 'February',
    march: 'March',
    april: 'April',
    may: 'May',
    june: 'June',
    july: 'July',
    august: 'August',
    september: 'September',
    october: 'October',
    november: 'November',
    december: 'December',
    previewWillBeAvailable: 'Previews will become available when customizing posts',
    theDayIsOver: 'The day is over',
    funKIReplyDesc: 'Your Ultimate AI Social Post Finder & Replier. FunKIReply helps you find the right posts and create brand-specific AI replies efficiently.',
    funKIBooksDesc: 'Create amazing PDF based on artificial intelligence in a couple of clicks.',
    funKITubeDesc: 'Create amazing videos based on artificial intelligence in a couple of clicks.',
    deletePost: 'Are you sure you want to delete this post?',
    youAreGoingToDelete: 'You\'re going to delete this channel',
    deleteChannelDescription: 'You will no longer be able to post to this channel, all existing posts and data will be deleted and cannot be recovered. This action cannot be undone.<br><br>Having issues with your connection? We advise using the refresh connection option.',
    emptyMentions: 'Sorry, there seems to be no posts for such filters. Try changing the filters or running instant fetch in the advanced settings.',
    selectNetworks: 'Select social profile (s) where you want to see posts from.',
    advanceSettingsDesc: 'Advance setting search options for mentions of your brand based on keywords.',
    teamMembersSubtitle: 'Team feature that allows you to invite your team to your account. Together, you can collaborate on projects and seamlessly work towards achieving your creative aspirations.',
    youDontHaveMembers: 'So far, you don\'t have any members on your team',
    provideDetailsOfMember: 'Provide details of the prospective member',
    selectTheServices: 'Select the service access that the member will have',
    allServicesThatAreAvailable: 'All services that are available to you will automatically be available to the member. When you get access to one more service, it will automatically become available to the member.',
    invitationSent: 'Invitation sent',
    weHaveAlreadySentAnEmail: 'We have already sent an email to the member\'s mailbox with a confirmation link. As soon as he confirms joining your team, you will be notified.',
    emailPlaceholder: 'e.g. member-email{\'@\'}domain.com',
    aspectRatio: 'Aspect Ratio',
    square: 'Square (1:1)',
    portrait: 'Portrait (9:16)',
    widescreen: 'Widescreen (16:9)',
    squareDescription: 'Square - Recommended for Facebook, Instagram and X',
    portraitDescription: 'Portrait - Recommended for Pinterest and TikTok',
    widescreenDescription: 'Widescreen - Recommended for LinkedIn',
    loseChanges: 'You\'ll lose all your changes, this can\'t be undone.',
    paymentProvidersDescription: 'Here you can add a Payment provider so that you can receive money for your PDF. After adding the payment provider here, you can link it to your PDF in the PDF settings.',
    noConnectedProvider: 'You don\'t have <br> connected <br> Payment providers',
    landingPreview: 'Preview landingpage',
    thankyouPagePreview: 'Thank you page preview',
    uploadYourOwnMedia: 'Upload your own media',
    videoEmbedUrl: 'Video embed URL',
    videoEmbedUrlPlaceholder: 'e.g. https://www.youtube.com/embed/qwe123qwe OR https://player.vimeo.com/video/1234567890',
    recommendedSize: 'Recommend size {0}',
    unlockYourBookNow: 'Unlock your book now',
    getItNowForFree: 'Get it now for free',
    booksDomainSubtitle: 'Truly make your PDF pages unique and change settings to your liking. You can adjust tracking codes, use a custom domain and fully adapt the design of your PDF download pages. Best to start right away!',
    noBooksDomainsSubtitle: 'Please connect your FunKI PDF tool with a domain. Once connected, you’ll find an overview of all domains on this page.',
    chapterWithAi: 'Chapter with AI',
    blankChapter: 'Blank chapter',
    youDontHaveChapters: 'You don\'t have any chapters yet.',
    createYourFirstChapter: 'Create your first chapter',
    beforeYouStartGeneratingChapter: 'Before you start generating a chapter, fill in your book information to get more relevant content. Approach it consciously, as the result directly depends on it.',
    pageDoesntExist: 'Unfortunately, such a page does not exist.',
    weCouldntFindPage: 'We couldn\'t find such a page, or the page was removed.',
    contentShouldNotBeEmpty: 'Content should not be empty',
    youCantDeleteLastChapter: 'You can\'t delete a single chapter',
    youDontHavePosts: 'You don\'t have any scheduled posts yet.',
  },
  label: {
    assistantPlaceholder: 'Our AI Assistant will<br> help you with any<br> questions',
    iamAlreadyWriting: 'I\'m already writing...',
    assistantWrites: 'Assistant writes...',
    aiInputPlaceholder: 'You message (eg. Need a sales text for a website on the topic “your topic”)',
    improve: 'Improve',
    short: 'Short',
    punchier: 'Punchier',
    use: 'Use',
    insert: 'Insert',
    selectedText: 'Selected text',
    customAction: 'Custom action',
    whatDoYouWantToDo: 'What do you want to do?',
    regenerateTitle: 'Attention, <br>the page content <br>will be overwritten.',
    regenerateDesc: 'if you have already made <br>changes on the page, then the page<br> content will be completely overwritten after re-generation.',
    errorGeneration: 'An error occurred during generation',
    errorGenerationDesc: 'You can repeat the generation or edit the page manually.',
    pageCreatedSuccessfully: 'The page was created successfully',
    pageCreatedSuccessfullyDesc: 'Now you can edit it',
    weStartedCreatingContent: 'We have started creating content for your page.',
    weStartedCreatingContentDesc: 'Wait for the creation to finish, and then you can edit the page.',
    takeBook: 'Take the book',
    globalTrackingCodes: 'Global tracking codes',
    deleteDomain: 'Delete domain',
    landingNotCreated: 'Landing page is not created',
    thankyouNotCreated: 'Thank You page is not created',
    publicURL: 'Public URL',
    back: 'Back',
    addItem: 'Add item',
    promoText: 'Promo text',
    paid: 'Paid',
    gift: 'Gift',
    rating: 'Rating',
    createLandingPage: 'Create landing page',
    createThankYouPage: 'Create "Thank you" page',
    footer: 'Footer',
    links: 'Links',
    footerLogoImage: 'Footer logo image',
    additionalNotice: 'Additional notice',
    callToAction: 'Call to action',
    disableComments: 'Comments aren\'t available due to your account\'s privacy settings.',
    disableDuetAndStitch: 'Since your account is private, others can\'t reuse your content.',
    duet_and_stitch: 'Duet and Stitch aren’t available on videos from private accounts',
    oldPassword: 'Old password',
    confirmPassword: 'Confirm password',
    readNow: 'Read now',
    borderSize: 'Border size',
    padding: 'Padding',
    borderColor: 'Border color',
    borderRadius: 'Border radius',
    backgroundColor: 'Background color',
    italics: 'Italics',
    fontColor: 'Font color',
    fontSize: 'Font size',
    fontStyleItalic: 'Font style italic',
    fontFamily: 'Font family',
    bookTitle: 'Book title',
    advancedSettings: 'Advanced settings',
    customizeTemplateColor: 'Customize template color',
    generate: 'Generate',
    cover: 'Cover',
    bookCoverGenerationModel: 'PDF cover generation model',
    autoresponderName: 'Autoresponder name',
    googleSpreadSheetUrl: 'Google SpreadSheet URL',
    apiKeyProvider: 'API Key',
    enableDoi: 'Enable DOI',
    addHeaders: 'Add headers',
    headerTrackingCode: 'Header tracking code',
    footerTrackingCode: 'Footer tracking code',
    buttonColor: 'Button color',
    buttonIconColor: 'Button icon color',
    lockScreenButtonText: 'Lock screen button text',
    lockScreenButtonIcon: 'Lock screen button icon',
    lockScreen: 'Lock screen',
    currency: 'Currency',
    price: 'Price',
    products: 'Produkts',
    addAutoresponders: 'Add autoresponders',
    paywall: 'Paywall',
    favicon: 'Favicon',
    publishBook: 'Publish PDF',
    metaTitle: 'Meta title',
    seo: 'SEO',
    trackingCode: 'Tracking Code',
    design: 'Design',
    access: 'Access',
    icon: 'Icon',
    background: 'Background',
    passwordProtected: 'Password protected',
    required: 'Required',
    bookName: 'PDF name',
    salesLandingPage: 'Sales landing and “Thank you” pages',
    landingSectionTitle: 'Sell your PDF using a landing page',
    landingSectionDesc: 'Use our custom designed sales landing page and “Thank You” pages for your PDF. Customize them to your liking! Control the colors, add your logo and images or screenshots of your PDF, use your own content or generate it with our AI.',
    landingPage: 'Landing page',
    landingPageDesc: 'This is the landing page of your PDF that users will see before buying.',
    thankYouPage: 'Thank you page',
    thankYouPageDesc: '<p>The “Thank you” page that will appear after your book is purchased.</p><p> Copy the link to the “Thank You” page and specify it in the Digistore24 settings of the product you have linked to this PDF.</p>',
    about: 'About',
    chapters: 'Chapters',
    structure: 'Structure',
    bookGenerator: 'PDF-Generator',
    nextGeneration: 'Next Generation',
    reachedLimit: 'You have reached the limit.  There are {limit} Keywords available to you in total.',
    limitTooltip: 'This Keyword has been added over the limit. You will be able to start a search on it after: {date}',
    instantSearchAvailableLater: 'The search for mentions by some keywords will be available later',
    instantSearchAvailableLaterDesc: 'Since you have previously reached your keyword limit, you can search for mentions of newly added keywords <b>{newKeywords}</b> after the date that is specified on the Keywords page for each new Keywords. Now only the following keywords will be searched: <b>{oldKeywords}</b>',
    searchAvailableLater: 'The search for mentions will be available later',
    searchAvailableLaterDesc: 'Since you previously reached the limit on the number of keywords, you will be able to start a search for mentions for newly added keywords after {date}',
    availableSearching: 'Available to searching after',
    saveAsDraft: 'The post will be saved as a draft',
    invalidTikTokMedia: 'Your video should be no longer than {duration} seconds.',
    isAvailableTikTokCreatePostByPostContent: 'You need to indicate if your content promotes yourself, a third party, or both.',
    paidPartnership: 'Paid partnership',
    promotionalContent: 'Promotional content',
    aiGenerated: 'Creator labeled as AI-generated',
    brandedContentMsg: 'By posting, you agree to TikTok\'s Branded <a target="_blank" href="https://www.tiktok.com/legal/page/global/bc-policy/en" class="text-primary">Content Policy</a> and <a target="_blank" class="text-primary" href="https://www.tiktok.com/legal/page/global/music-usage-confirmation/en">Music Usage Confirmation</a>',
    yourBrandMsg: 'By posting, you agree to TikTok\'s <a target="_blank" href="https://www.tiktok.com/legal/page/global/music-usage-confirmation/en" class="text-primary">Music Usage Confirmation</a>',
    brandedContent: 'Branded content',
    brandedContentVisibility: 'Branded content visibility cannot be set to private',
    brandedContentDesc: 'Your photo/video will be labeled as \'Paid partnership\'',
    brandedContentDescDisable: 'To disclose your post as branded content, your post must be set to “Public”.',
    brandedContentDescActive: 'You are in a paid partnership with a brand. After posting the video, open your TikTok mobile app and link the campaign under the video’s “Ad settings”',
    yourBrand: 'Your brand',
    yourBrandDesc: 'Your photo/video will be labeled as \'Promotional content\'',
    yourBrandDescActive: 'You are promoting yourself or your own business.',
    disclosePostContent: 'Disclose post content',
    disclosePostContentDesc: 'Let others know this post promotes a brand, product or service.',
    aiGeneratedContent: 'AI-Generated content',
    aiGeneratedContentDesc: 'Add this label for aigc. <a href="https://www.tiktok.com/tns-inapp/pages/ai-generated-content" class="text-primary" target="_blank">Learn more</a>',
    selectPrivacy: 'Select privacy',
    whoCanSee: 'Who can watch this post',
    allowUsersTo: 'Allow users to',
    fetchPeriod: 'Fetch period',
    allKeywords: 'All Keywords',
    mentions: 'Mentions',
    showNewOnly: 'Show New only',
    showSkippedOnly: 'Show Skipped only',
    pleaseWait: 'Please wait for 1-2 minutes',
    pleaseWaitDesc: 'We are working to bring you new posts based in your keywords',
    error: 'Error',
    markAsReplied: 'Mark as replied',
    unmark: 'Unmark',
    skip: 'Skip',
    replied: 'Replied',
    new: 'New',
    generateReply: 'Generate Reply',
    generationReply: 'Generating reply...',
    viewPost: 'View post',
    everyDay: 'Every day',
    everyWeek: 'Every week',
    everyMonth: 'Every month',
    everyYear: 'Every year',
    advanceSettings: 'Advance setting',
    chooseCountry: 'Choose Country',
    chooseLanguage: 'Choose language',
    whenFetchPosts: 'When to fetch posts',
    instantFetch: 'Instant fetch',
    deleteKeyword: 'Delete keyword',
    addPositiveKeyword: 'Add positive keyword',
    showMore: 'Show more',
    searchImages: 'Search images...',
    imageSearch: 'Image search',
    typeImageDescription: 'Write a description of the image or keywords to find the images',
    searching: 'Searching...',
    editSmtp: 'Edit SMTP',
    deleteSmtp: 'Delete SMTP',
    allPosts: 'All Posts',
    allChannels: 'All Channels',
    channels: 'Channels',
    addPostAuthor: 'Add post author',
    authors: 'Authors',
    addAuthor: 'Add author',
    editAuthor: 'Edit author',
    authorName: 'Author name',
    authorDescription: 'Author description',
    add: 'Add',
    exportSuccess: 'File created',
    dontHave: 'You currently don’t have any leads',
    dontHaveLead: 'Fill out the blog, post and enable subscription and the service will start collecting leads.',
    dontHaveLeadBooks: 'You’ll find an overview of all your leads here once someone downloaded any of your PDF documents.',
    delete: 'Delete',
    deleteLead: 'Delete lead',
    download: 'Download',
    exportContacts: 'Export contact',
    takeSomeTime: 'This may take some time. Please wait',
    export: 'Export',
    confirmed: 'Confirmed',
    pending: 'Pending',
    rejected: 'Rejected',
    leadSubscribePage: 'Source',
    leadCreatedAt: 'Create contact',
    status: 'Status',
    active: 'Active',
    inactive: 'Inactive',
    tls: 'TLS',
    addBrandVoice: 'Add Brand Voice',
    addSmtp: 'Add new SMTP',
    smtpActivity: 'SMTP Activity',
    fromName: 'From name',
    fromEmail: 'From email',
    smtpServer: 'SMTP server',
    port: 'Port',
    secure: 'Secure',
    smtpAuth: 'SMTP Authentication',
    smtpUser: 'SMTP User',
    smtpPassword: 'SMTP Password',
    internalPage: 'Internal page',
    magic: 'Magic',
    rewrite: 'Rewrite',
    expand: 'Expand',
    correct: 'Correct',
    optimize: 'Optimize',
    liveTrainings: 'Live trainings',
    ok_thanks: 'Ok, thanks',
    targetKeywords: 'Target keywords',
    apply: 'Apply',
    rememberMe: 'Remember me',
    country: 'Country',
    language: 'Language',
    courses: 'Courses',
    currentCountry: 'Country: {country}',
    currentLanguage: 'Language: {language}',
    home: 'Home',
    limits: 'Limits',
    support: 'Support',
    author: 'Author',
    share: 'Share',
    seeAlso: 'See also',
    allArticles: 'All articles',
    reachToAverage: 'Reach {0}% to average competitors',
    defaultDomain: 'Default domain',
    colorTemplate: 'Color Template',
    logo: 'Logo',
    customBanner: 'Custom banner',
    link: 'Link',
    bannerUrl: 'Banner URL',
    headerLink: 'Header link',
    footerLink: 'Footer link',
    articlePublish: 'Article publish',
    slug: 'Slug',
    titleH1: 'Title H1',
    briefComment: 'Brief comment',
    addMultimedia: 'Add multimedia (optional)',
    photo: 'Photo',
    aiImage: 'AI image',
    domain: 'Domain',
    connectDomain: 'Connect Domain',
    editDomain: 'Edit Domain',
    pageTitle: 'Page title',
    pageUrl: 'Page URL',
    keyword: 'Keyword',
    keywords: 'Keywords',
    you: 'You',
    target: 'Target',
    metaAuthor: 'Meta author',
    metaAltText: 'Meta Alt text',
    bold: 'Bold',
    italic: 'Italic',
    underline: 'Underline',
    strikethrough: 'Strikethrough',
    numberedList: 'Numbered list',
    bulletedList: 'Bulleted list',
    alignLeft: 'Align left',
    alignCenter: 'Align center',
    alignRight: 'Align right',
    volume: 'Volume',
    difficulty: 'Difficulty',
    veryEasy: 'Very easy',
    easy: 'Easy',
    possible: 'Possible',
    difficult: 'Difficult',
    hard: 'Hard',
    veryHard: 'Very hard',
    logout: 'Logout',
    generation: 'Generation',
    title: 'Title',
    metaDescription: 'Meta description',
    metaKeywords: 'Meta keywords',
    imageAnalysis: 'Image analysis',
    contentLength: 'Content length',
    search: 'Search',
    firstName: 'First name',
    lastName: 'Last name',
    subdomain: 'Subdomain',
    subdomainName: 'Subdomain name',
    preference: 'Preference',
    systemLanguage: 'System Language',
    emptyBlogPage: 'Empty blog page',
    addKeyword: 'Add keyword',
    addNegativeKeyword: 'Add negative keyword',
    negativeKeywords: 'Negative keywords',
    templateLayout: 'Template layout',
    url: 'URL',
    notification: 'Notification',
    addVoice: 'New Voice',
    myVoice: 'My voice',
    brandVoice: 'Brand Voice',
    enterBrandedText: 'Enter Branded Text',
    nameThisVoice: 'Name this voice',
    makeThisVoiceDefault: 'Make this voice default',
    editVoice: 'Edit voice',
    deleteVoice: 'Delete voice',
    newsletter: 'Newsletter',
    emailChains: 'Email chains',
    autoresponders: 'Autoresponders',
    addEmailChain: 'Add Email chain',
    emailChainName: 'Email chain name',
    name: 'Name',
    smtp: 'SMTP',
    defaultSmtp: 'Default SMTP',
    addAutoresponder: 'Add Autoresponder',
    myAutoresponder: 'My Autoresponder',
    editAutoresponder: 'Edit autoresponder',
    autoresponderSettings: 'Autoresponder settings',
    deleteAutoresponder: 'Delete autoresponder',
    type: 'Type',
    apiUrl: 'API URL',
    apiKey: 'API Key',
    googleSpreadsheetUrl: 'Google SpreadSheet URL',
    login: 'Log in',
    selectType: 'Select type',
    selectPage: 'Select page',
    textButton: 'Text button',
    privacyPolicyLink: 'Privacy policy link',
    description: 'Description',
    myEmailChains: 'My Email chains',
    editEmailChain: 'Edit email chain',
    deleteEmailChain: 'Delete email chain',
    newMail: 'New mail',
    subject: 'Subject',
    sendAfter: 'Send after',
    emailText: 'Email text',
    ctaLabel: 'CTA label',
    ctaUrl: 'CTA URL',
    previewEmail: 'Preview email',
    tags: 'Tags',
    mailLists: 'Mail Lists',
    subscription: 'Subscription',
    range: 'Range',
    dayOfCycle: 'Day of cycle',
    campaign: 'Campaign',
    descriptionOfThePicture: 'Description of the picture',
    imprint: 'Imprint',
    privacy: 'Privacy',
    sitemap: 'Sitemap',
    blogName: 'Blog name',
    createEmptyPost: 'Create empty post',
    createPostWithAI: 'Create post with AI',
    blogSlug: 'Blog slug',
    noindex: 'No index',
    wordpressPluginKey: 'WordPress plugin key',
    metaTags: 'Meta tags',
    headMetaTag: 'Head meta tag',
    insertYourMetaTag: 'Insert your meta tag',
    analytics: 'Analytics',
    relatedQuestions: 'Related questions',
    optimized: 'Optimized',
    peopleAlsoAsk: 'People also ask',
    aiSuggestedQuestions: 'AI suggested questions',
    nofollow: 'Nofollow link',
    noopener: 'Noopener link',
    noreferrer: 'Noreferrer link',
    recent: 'Recent',
    history: 'History',
    today: 'Today',
    yesterday: 'Yesterday',
    backToRecent: 'Back to recent',
    upgradePlans: 'Upgrade plans',
    plans: 'Plans',
    free: 'Free',
    pro: 'Pro',
    cloud: 'Cloud',
    yearly: 'yearly',
    popular: 'Popular',
    category: 'Category',
    manage: 'Manage',
    categoryName: 'Category name',
    manageCategory: 'Manage category',
    addCategory: 'Add category',
    uncategorized: 'Uncategorized',
    planAccess: 'Plan access',
    welcome: 'Welcome',
    left: 'Left',
    articles: 'articles',
    ideas: 'Ideas',
    competitors: 'Competitors',
    service: 'Service',
    createPost: 'Create post',
    refreshConnection: 'Refresh connection',
    disconnectChannel: 'Disconnect channel',
    authenticate: 'Authenticate',
    authenticateWithFacebook: 'Authenticate with Facebook',
    results: 'Results',
    toneOfVoice: 'Tone of Voice',
    text: 'Text',
    channel: 'Channel',
    inviteTeamMember: 'Invite Team member',
    editTeamMember: 'Edit Team member',
    myTeam: 'My team',
    invite: 'Invite',
    fullAccess: 'Full access',
    someServices: 'Some services',
    allowFullAccess: 'Allow full access',
    gotIt: 'Got it',
    crop: 'Crop',
    week: 'Week',
    month: 'Month',
    visibility: 'Visibility',
    license: 'License',
    createBook: 'Create PDF',
    addChapter: 'Add chapter',
    desktop: 'Desktop',
    mobile: 'Mobile',
    tablet: 'Tablet',
    contacts: 'Contacts',
    addNewAbove: 'Add new above',
    addNewBelow: 'Add new below',
    linkSharing: 'Link sharing',
    publicLink: 'Public link',
    microsoftWord: 'Microsoft Word',
    pdf: 'PDF',
    html: 'HTML',
    addYourNote: 'Add your Note',
    addNote: 'Add Note',
    endChapter: 'End chapter',
    createNewChapter: 'Create new chapter',
    setting: 'Setting',
    content: 'Content',
    note: 'Note',
    createContact: 'Create contact',
    contactName: 'Contact name',
    mail: 'Email',
    myProvider: 'My payment providers',
    providers: 'Payment providers',
    editProvider: 'Edit payment provider',
    deleteProvider: 'Delete payment provider',
    selectStatus: 'Select status',
    colorSettings: 'Color settings',
    offer: 'Offer',
    timerDuration: 'Timer Duration',
    buttonText: 'Button text',
    headLogoImage: 'Head logo image',
    header: 'Header',
    promo: 'Promo',
    subtitle: 'Subtitle',
    media: 'Media',
    video: 'Video',
    imageLeft: 'Image left',
    imageRight: 'Image right',
    items: 'Items',
    overview: 'Overview',
    createItem: 'Create item',
    editItem: 'Edit item',
    featuresGrid: 'Features grid',
    laptopImage: 'Laptop image',
    phoneImage: 'Phone image',
    featuresList: 'Features list',
    carousel: 'Carousel',
    headlines: 'Headlines',
    headlinesWithButton: 'Headlines with button',
    buttonUrl: 'Button URL',
    aiGeneratedPDF: 'AI generated PDF',
    blankPDF: 'Blank PDF',
    createNewPDF: 'Create new PDF',
    chapterTitle: 'Chapter title',
    pdfDetails: 'PDF details',
    colors: 'Colors',
    fontSettings: 'Font settings',
    h2FontSize: 'Title H2 font size',
    h3FontSize: 'Title H3 font size',
    h4FontSize: 'Title H4 font size',
    pFontSize: 'Paragraph font size',
    noteFontSize: 'Note font size',
    publishNow: 'Publish now',
    moveToDraft: 'Move to draft',
    duplicate: 'Duplicate',
    discover: 'Discover',
  },
  button: {
    retry: 'Retry',
    replace: 'Replace',
    remove: 'Remove',
    addNewProviders: 'Add new providers',
    selectPayment: 'Select payment provider',
    newPayment: 'Add payment provider',
    moveToCategory: 'Move to category',
    saveSetting: 'Save setting',
    downloadBook: 'Download book',
    no: 'No',
    apply: 'Apply',
    next: 'Next',
    saveAutoresponder: 'Save autoresponder',
    addFirstEmail: 'Add first email',
    newEmail: 'New email',
    selectMailChains: 'Select mail chains',
    newMailChains: 'New mail chains',
    addAutoresponder: 'Add autoresponder',
    addNewAutoresponder: 'Add new autoresponder +',
    changeImage: 'Change image',
    loadImage: 'Load image',
    bookSettings: 'PDF settings',
    ok: 'Ok',
    regenerateNow: 'Regenerate now',
    regenerate: 'Regenerate',
    generating: 'Generating...',
    runInstantFetch: 'Run instant fetch',
    edit: 'Edit',
    saved: 'Saved',
    saveToCloud: 'Save to cloud',
    original: 'Original',
    wide: 'Wide',
    stories: 'Stories',
    portrait: 'Portrait',
    square: 'Square',
    rename: 'Rename',
    download: 'Download',
    saveAsDraft: 'Save as draft',
    shareNow: 'Share now',
    editPage: 'Edit page',
    view: 'View',
    addSmtp: 'Add SMTP',
    change: 'Change',
    editPost: 'Edit post',
    viewPost: 'View post',
    copyUrl: 'Copy URL',
    delete: 'Delete',
    reset: 'Reset',
    resetToDefault: 'Reset to default',
    saveSettings: 'Save settings',
    addLink: 'Add link',
    shareArticle: 'Share Article',
    save: 'Save',
    cancel: 'Cancel',
    more: 'More',
    upgrade: 'Upgrade',
    update: 'Update',
    reviewSubheadings: 'Review subheadings',
    generate: 'Generate',
    checkDomainConnection: 'Check domain connection',
    savePage: 'Save page',
    createContent: 'Create content',
    connected: 'Connected',
    noConnected: 'No connected',
    competitorOverview: 'Competitor overview',
    refreshOutline: 'Refresh outline',
    back: 'Back',
    preview: 'Preview',
    startEditing: 'Start editing',
    published: 'Published',
    noPublish: 'No publish',
    findKeywords: 'Find Keywords',
    deleteMyAccount: 'Delete my account',
    deleteLink: 'Delete link',
    newPost: 'New post',
    backToPosts: 'Back to Posts',
    backToArticles: 'Back to Articles',
    close: 'Close',
    ended: 'Ended',
    clickHere: 'Click here',
    analyze: 'Analyze',
    myVoice: 'My Voice',
    copy: 'Copy',
    select: 'Select',
    insertImage: 'Insert image',
    downloadSitemap: 'Download sitemap',
    createBlog: 'Create blog',
    goToEditor: 'Go to editor',
    activate: 'Activate',
    deleteBlog: 'Delete blog',
    startAnalysis: 'Start analysis',
    activateBlog: 'Activate blog',
    readTheGuide: 'Read the guide',
    syncPost: 'Sync post',
    syncingFailed: 'Syncing failed',
    synchronize: 'Synchronize',
    downloadPlugin: 'Download plugin',
    insert: 'Insert',
    inserted: 'Inserted',
    answer: 'Answer',
    generateMore: 'Generate more',
    clearHistory: 'Clear history',
    clear: 'Clear',
    loadMoreResults: 'Load more results',
    allKeywords: 'All keywords',
    newCategory: 'New category',
    create: 'Create',
    done: 'Done',
    getYourDeal: 'Get your 72h deal now',
    addAuthor: 'Add author',
    newChannel: 'New Channel',
    connect: 'Connect',
    refresh: 'Refresh',
    backToChannels: 'Back to Channels',
    startConnecting: 'Start Connecting',
    addFirstChannel: 'Add First Channel',
    createPost: 'Create post',
    accept: 'Accept',
    decline: 'Decline',
    saveCrop: 'Save crop',
    addNewThread: 'Add new thread',
    addAndSaveToCloud: 'Crop and save to cloud',
    copyText: 'Copy text',
    openInNewTab: 'Open in new tab',
    copyPublicLink: 'Copy public link',
    resetColor: 'Reset color',
    discardChanges: 'Discard Changes',
    addPaymentProvider: 'Add payment provider',
    addItem: 'Add item',
    buyBook: 'Buy book',
    addFirstChapter: 'Add first chapter',
    saveNext: 'Save & next',
    stopGeneration: 'Stop generation',
  },
  profile: {
    myProfile: 'My profile',
    security: 'Security',
    email: 'Email address',
    currentEmail: 'Current email address',
    changeEmail: 'Change email',
    newEmail: 'New email address',
    chooseEmail: 'Choose new email',
    confirmWithPassword: 'Confirm with password',
    hasEmailChangeRequest: 'Email change request has been initiated. We have sent a notification with an email confirmation link to ',
    password: 'Password',
    currentPassword: 'Current password',
    changePassword: 'Change password',
    requestForChangeSent: 'Request for change sent',
    oldPassword: 'Old password',
    newPassword: 'New password',
    confirmPassword: 'Confirm password',
    confirmationWasSentPrevious: 'A confirmation email has <br>been sent to your previous <br>email.',
    confirmationWasSent: 'A confirmation email has <br>been sent to your<br>email.',
    passwordChanged: 'Password changed successfully',
  },
  blog: {
    settings: 'Blog Settings',
    settingsDesc: 'Make your blog truly unique and change settings to your liking. You can adjust tracking codes, use a custom domain and fully adapt the design of your blog. Best to start right away!',
    general: 'General',
    title: 'Blog Title',
    description: 'Blog Description',
    keywords: 'Blog Keywords',
    language: 'Blog language',
    languageHint: 'This language will be used by default to generate blog articles',
    country: 'Blog country',
    countryHint: 'This country will be used by default to generate blog articles',
    customDomain: 'Custom Domain',
    customDesign: 'Custom design',
    customDesignHeader: 'You can customize the blog <br> design to your liking',
    customDesignDescription: 'Choose brand colors, change your logo<br> and much more',
    trackingCode: 'Tracking Code',
    headCode: 'Head code',
    footerCode: 'Footer code',
    defaultValueHint: 'The default value from the Blog Settings is used.',
    allGenerated: 'All generated',
    newPost: 'New post',
    publish: 'Publish',
    noPublish: 'No publish',
    deletePost: 'Delete post',
    noPostsYet: 'You don\'t have <br> any Blog Posts yet',
    generateYourFirstText: 'Generate your first text. <br> Artificial intelligence will <br> help you with this',
    blogUrl: 'Blog URL',
    dontHavePosts: 'You don\'t have <br> any Blog Posts yet',
    dontHavePostsDesc: 'Generate your first text. <br> Artificial intelligence will <br> help you with this',
    noPostFoundMatches: 'No post found matches <br> this query',
  },
  domain: {
    getMoreBlog: 'Get more out of your blog and customize your brand. Add and connect domains with a few simple steps and start reaching even more viewers and leads.',
  },
  dashboard: {
    noBlogPosts: 'You don\'t have <br> Blog Post yet',
    noKeywords: 'You don\'t have <br> keywords yet',
    noKeywordsDesc: 'Find your first keywords and create <br> a new blog post based on them',
    addFirstPost: 'Add first Post',
    searchKey: 'Search Key',
    project: 'Project',
    keywords: 'Keywords',
    noPosts: 'No post found <br> matches this query',
    latest: 'Latest',
    blogPosts: 'Blog posts',
    blog: 'Blog',
    seoScore: 'SEO Score',
    startFillingBlog: 'Start filling out your blog and we will build an analysis of your blog',
  },
  validation: {
    requiredField: '{missingProperty} is required',
    required: 'Field is required',
    email: 'E-mail is not valid',
    phone: 'Phone is not valid',
    href: 'Link must be valid and start with https:// or mailto: or tel:',
    url: 'Link must be valid and start with http:// or https://',
    notNumber: 'Value must be number',
    invalidPassword: 'Invalid password',
    invalidValue: 'Invalid value',
    minLength: 'The {field} field must be at least {min} characters',
    maxLength: 'The {field} field may not be greater than {max} characters',
    betweenNumber: 'The {field} field must be between {min} and {max}',
    subdomain: 'Subdomain can only contain letters, numbers and hyphen',
    passwordIsNotMatched: 'Password is not matched',
    slugAlreadyTaken: 'Slug already taken',
    bannerLink: 'Please fill banner link field',
    invalidLink: 'Invalid link',
  },
  notification: {
    emailSuccessfullyChanged: 'Email successfully changed',
    successfullySaved: 'Successfully saved!',
    successfullyResetted: 'Succesfully resetted!',
    successCopy: '{element} copied',
    copiedToTheClipboard: 'The {element} has been <br/> copied to the clipboard',
    linkCopied: 'Link copied successfully',
    linkUpdated: 'Link updated successfully',
    linkDeleted: 'Link deleted successfully',
    inputValidUrl: 'Input valid URL',
    fileIsUploaded: 'File uploaded',
    passwordChanged: 'Password has been changed successfully',
    settingsSaved: 'Settings saved successfully',
  },
  error: {
    imageMustHaveSameRatio: 'Images must have the same width/height ratio. Crop images to the same width/height ratio.',
    keywordsLimitReached: 'You can only add up to {n} keywords',
    invalidConfirmationCode: 'Invalid confirmation code',
    invalidForm: 'Form is not valid!',
    headlineCannotBeWithout: 'Headline H2 cannot be without headline H3',
    pleaseSelectService: 'Please select at least 1 service',
    passwordIsNotMatched: 'Password is not matched',
  },
  colors: {
    fontColor: 'Font',
    primaryColor: 'Primary',
    iconColor: 'Icon',
    borderColor: 'Border',
    cardColor: 'Card',
    backgroundColor: 'Background',
    textColor: 'Text',
    titleColor: 'Title',
    timerColor: 'Timer',
  },
  layoutTitles: {
    blog: 'Blog post',
    paymentProviders: 'Payment providers',
    dashboard: 'Dashboard',
    keywords: 'Keywords',
    blogSettings: 'Blog settings',
    setting: 'Setting',
    domains: 'Domains',
    domain: 'Domain',
    myProfile: 'My profile',
    security: 'Security',
    liveTrainings: 'Live trainings',
    brandVoice: 'Brand Voice',
    leads: 'Leads',
    emailChains: 'Email chains',
    autoresponder: 'Autoresponder',
    smtp: 'SMTP',
    calendar: 'Calendar',
    channels: 'Channels',
    planned: 'Planned',
    mentions: 'Mentions',
    addBrand: 'Add Brand',
    replies: 'Replies',
    replied: 'Replied',
    settings: 'Settings',
    teamMembers: 'Team members',
    myBooks: 'My PDF',
    outliers: 'Outliers',
    myVideos: 'My videos',
    myThumbnails: 'My thumbnails',
  },
  seoParameters: {
    hasCoverImage: 'Has cover image',
    includesTargetKeyword: 'Includes target keyword',
    characterCountBetween: 'Character count between {count}',
    keywordsInCloseProximity: 'Keywords in close proximity',
    targetKeywordInInitialPart: 'Target keyword in initial part',
    uniquinessVsCompetitors: 'Uniqueness vs competitors',
  },
  voices: {
    positive: 'Positive',
    upset: 'Upset',
    powerful: 'Powerful',
    joking: 'Joking',
    quiet: 'Quiet',
    urgent: 'Urgent',
    soft: 'Soft',
    polite: 'Polite',
    encouraging: 'Encouraging',
    formally: 'Formally',
    general: 'General',
    professional: 'Professional',
    funny: 'Funny',
    dramatic: 'Dramatic',
    witty: 'Witty',
    sarcastic: 'Sarcastic',
    sad: 'Sad',
    spirituel: 'Spirituel',
    intellectual: 'Intellectual',
  },
  leads: {
    activecampaign: 'ActiveCampaign',
    getresponse: 'GetResponse',
    googlespreadsheets: 'Google SpreadSheets',
    klicktipp: 'KlickTipp',
    mailchimp: 'Mailchimp',
    quentn: 'Quentn',
  },
  wpPlugin: {
    installWPPlugin: 'Install the FunKITools plugin on your WordPress site and add this key in the plugin settings. Create posts and sync them with your blog on a WordPress site.',
    howToConnectFunkyPlugin: 'How to connect FunKITools WP plugin',
    howToConnectWPPlugin: 'How to connect WP plugin',
    howToinstallPlugin: 'How to install the plugin',
    connectingWPPlugin: 'Connecting WP plugin',
    connectingWPPluginTitle: 'Connecting WP plugin',
    youCanSynchronizeThePost: 'You can synchronize the post with an external site where the WP plugin is installed and configured.',
    loginToTheWPAdminArea: 'Log in to the WP admin area of your website',
    wpAdminAreaIsUsuallyLocated: 'The WP admin area is usually located at https://yourdomain.com/wp-admin/. If you can\'t log in to this address, check with your system administrator for the correct address and credentials.',
    goToAddNewPLugin: 'Go to “Add new plugin” and find the FunKITools plugin',
    inTheLeftMenuFindThePlugins: 'In the left menu, find the Plugins section and click on "Add a new plugin". On the page that opens, in the upper-right corner, enter the value "FunKITools" in the search field.',
    installTheFunkitoolsPlugin: 'Install the FunKITools plugin',
    youWillSeeTheRequiredPlugin: 'You will see the required plugin in the search results. Click on the "Install" button and follow the instructions.',
    activateTheFunkitoolsPlugin: 'Activate the FunKITools plugin',
    afterTheInstallationIsComplete: 'After the installation is complete, activate the plugin by clicking on the corresponding button next to the plugin.',
    pasteYourAPIKey: 'Paste your API key in the FunKITools plugin settings',
    afterTheInstallationIsCompleteYourPluginIsReady: 'After the installation is complete your plugin is ready to be used.',
    whereCanFindTheKey: 'Where can I find the API key?',
    goToBlogSettings: 'Go to blog settings',
    selectTheBlogYouNeed: 'Select the required blog and go to blog settings.',
    findTheWordpressPlugin: 'Find the WordPress plugin key section',
    findTheWordpressPluginDescription: 'Find the WordPress plugin key section containing your personal API key for integration with the FunKITools WP plugin.',
    copyTheWordpressKey: 'Copy the WordPress API key in blog settings',
    onceThePluginIsInstalled: 'Once the plugin is installed and activated, go back to your blog settings and copy the blog API key.',
    pasteTheKeyIntoSettings: 'Paste the API key into FunKITools plugin settings',
    goBackToTheAdminArea: 'Go back to the admin area of your WP website and open the FunKITools plugin settings. In the API Key field, paste the copied key and click Save button.',
    ifTheConnectionSuccess: 'You will see a corresponding message if the connection is successful.',
    firstDownloadThePlugin: 'First download the FunKITools plugin on the <a href="https://funkitools.ai/wp-en.html" target="_blank" class="text-primary">plugin download page</a>.',
    pluginDownload: 'plugin download page',
    downloadThePlugin: 'Download the FunKITools plugin',
    goToAddNewPlugin: 'Go to “Add new plugin” and upload plugin',
    goToAddNewPluginDescription: '1. In the left menu, find the “Plugins” section and click on the “Add New Plugin” section. <br> 2. On the page that opens, click on “Upload Plugin” in the upper left corner. <br> 3. Upload the .zip archive with the plugin downloaded in the first step.',
    installThePlugin: 'Install the FunKITools plugin',
    installThePluginDescription: 'Start the installation by clicking on the “Install Now” button.',
    activateThePlugin: 'Activate the FunKITools plugin',
    activateThePluginDescription: 'After the installation is complete, activate the plugin by clicking on the corresponding button next to the plugin.',
    pasteYourAPIKeyDescription: 'To configure the plugin, specify the blog API key in it, which you can find in the blog settings. If necessary, specify the author, categories and tags for the published posts by default.',
  },
  upgradePlan: {
    wordpressPlugin: 'WordPress Plugin',
    keywordTool: 'Keyword Tool',
    ownArticles: 'Own articles',
    aiArticles: 'AI-articles',
    blogHosting: 'Blog Hosting',
    seoOptimizing: 'Seo Optimizing',
    newsletterTools: 'Newsletter Tools',
    customBanner: 'Custom Banner',
    removeBranding: 'Remove FunKIBlog branding',
    blogTemplates: 'Blog Templates',
    webinars: 'Webinars',
    freePrice: '0€',
    proPrice: '249€ / yearly',
    cloudPrice: '1990€ / yearly',
    freeKeywordTool: '10 times once',
    freeOwnArticles: '5 / month',
    freeAiArticles: '3 times once',
    freeBlogHosting: 'Only Subdomain',
    freeSeoOptimizing: 'Unlimited for the first 14 days',
    proKeywordTool: '300 / monthly',
    proAiArticles: '60 / monthly',
    proBlogHosting: '1 Blog / own Domain',
    proSeoOptimizing: '30 articles',
    yourPlan: 'Your plan',
    moreBlog: '1 more blog',
    moreBlogPrice: '9€ / monthly',
    saleWithin: 'Sale within 70 hours',
    keywordToolUsed: 'Keyword Tool used',
    ownArticlesUsed: 'Own articles used',
    aiArticlesUsed: 'AI-articles used',
    seoOptimizingUsed: 'Seo Optimizing',
    keywordsLeftByTime: '<span class="text-black q-mr-sm">{used} keyword search requests</span> left out of <span class="text-black q-mx-sm">{limit}</span> until <span class="text-black q-ml-sm">{date}</span>',
    keywordsLeft: '<span class="text-black q-mr-sm">{used} keyword search requests</span> left out of <span class="text-black q-ml-sm">{limit}</span>',
    keywordsLeftByTimeLimitReached: '<span class="text-red-3 q-mr-sm">{used} keyword search requests</span> left out of <span class="text-black q-ml-sm">{limit}</span> until <span class="text-black q-ml-sm">{date}</span>',
    keywordsLeftLimitReached: '<span class="text-red-3 q-mr-sm">{used} keyword search requests</span> left out of <span class="text-black q-ml-sm">{limit}</span>',
    wordpressPluginTooltip: 'A plugin that allows you to seamlessly integrate and manage your content on WordPress.',
    keywordToolTooltip: 'A tool for effective research and analysis of keywords for better SEO performance.',
    ownArticlesTooltip: 'Ability to create and manage your own articles to generate unique and individual content.',
    aiArticlesTooltip: 'Automated generation of articles through artificial intelligence to quickly create content.',
    blogHostingTooltip: 'Reliable hosting for your blog with high availability and security.',
    seoOptimizingTooltip: 'Tools to optimize your content for search engines to achieve better rankings.',
    newsletterToolsTooltip: 'Features to create and manage newsletters for effective communication with your readers.',
    customBannerTooltip: 'Custom design and integration of banners on your website for advertising or information dissemination.',
    removeBrandingTooltip: 'Option to remove FunKIBlog branding to strengthen your own brand.',
    blogTemplatesTooltip: 'Templates for blogs to quickly and easily customize the design and layout of your website.',
    moreBlogTooltip: 'Option to create and manage an additional blog under the same account.',
  },
  reply: {
    toStartUsingService: 'To start using the service, add your brand',
    addFirstBrand: 'Add first Brand',
    addYourBrandDescription: 'Add your brand by specifying the brand name, website address and brand description. Add keywords describing your brand, select social networks in which to search for mentions of your brand and get a list of all mentions of your brand! Create reply for posts mentioning your brand on social networks in one click!',
    addBrand: 'Add brand',
    editBrand: 'Edit brand',
    next: 'Next',
    finish: 'Finish',
    brandName: 'Brand name',
    brand: 'Brand',
    socials: 'Socials',
    keywords: 'Keywords',
    congratulations: 'Congratulations!',
    youAddedBrand: 'You’ve successfully added your brand!',
    selectSocialProfile: 'Select social profile (s) where you want to see posts from.',
    aiSuggestedKeywords: 'AI Suggested Keywords',
    addPositiveKeywords: 'Add Positive Keywords',
    addNegativeKeywords: 'Add Negative Keywords',
    pleaseSelectNetwork: 'Please select at least 1 network',
    thisKeywordAdded: 'This keyword has already been added',
    myBrands: 'My brands',
    addNewBrand: 'Add new brand',
    deleteBrand: 'Delete brand',
    goToMentions: 'Go to mentions',
    beforeStartSearch: 'Before start search you need add keywords to brand.',
    emptyReplies: 'You haven\'t created any replies yet',
    emptyReplied: 'You haven\'t replied to a single mention yet',
    addVoice: 'Add voice',
    allSocialNetworks: 'All social networks',
    socialNetworks: 'Social networks',
    return: 'Return',
    restrictCountry: 'Restrict search to the selected Country',
    restrictCountryDescription: 'If activated may increase accuracy but reduce the number of results obtained.',
    restrictLanguage: 'Restrict search to the selected language',
    restrictLanguageDescription: 'If this option is activated, only pages with the selected language will be searched.',
    searchExactMatches: 'Search for exact matches',
    searchExactMatchesDesc: 'If this option is enabled, the search will be performed by exact matches of keywords. This way you get fewer but more relevant results, in some cases nothing will be found. Therefore, you should choose keywords more carefully in order to achieve the desired result.',
    markedAsReplied: 'Mentions marked as replied',
    markedAsSkipped: 'Mention marked as skipped',
    wasReturned: 'Mention was returned',
    markedAsUnreplied: 'Mention marked as unreplied',
  },
  teams: {
    statuses: {
      active: 'Active',
      disabled: 'Disabled',
      pending: 'Pending',
      rejected: 'Rejected',
    },
    resendInvite: 'Resend invite',
    editMemberAccess: 'Edit member access',
    deleteMember: 'Delete member',
    disableMember: 'Disable member',
    activateMember: 'Activate member',
    userDisabled: 'User successfully disabled',
    userActivated: 'User successfully activated',
    resend: 'Invitation sent',
    resendSuccess: 'Invitation was successfully sent',
    teams: 'Teams',
    hereYouWillSeeTheTeams: 'Here you will see the teams to which you have been invited and to which you have access.',
    toOwnTeam: 'To Own Team',
    newInvitations: 'New Invitations',
    youAreInvited: 'You are invited to {team}\'s team',
    acceptOrDecline: 'Accept or decline the invitation',
    teamName: '{team}\'s team',
    goToTeam: 'Go to team',
    leaveTeam: 'Leave a Team',
    youDontHaveAccess: 'You don\'t have access',
    changeTeam: 'Change team',
    youAreNotMember: 'You are not a member of any team.',
    youHaveNoTeams: 'You have no teams',
    team: 'Team',
    goToTeams: 'Go to Teams',
  },
  hint: {
    ds24: `You can find your DS24 API-Key under 'Settings' › 'Account access' › 'API keys. <br>
      1. Click on 'New API key' and generate new API-Key with the API permissions 'full a access'. <br>
      2. Copy this API-Key and paste it here. <br>
      3. Then click on 'Save'`,
  },
  placeholder: {
    findIcon: 'Find icon',
    graphic: 'Graphic (drawn)',
    photo: 'Realistic (photo)',
    searchContact: 'Search in contact...',
  },
  routeTitles: {
    'my-book': 'My PDF',
    'my-profile': 'My profile',
  },
};
